<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header">
        <h2 class="panel-title">
          {{ $t('settings') }}
        </h2>
      </header>

      <div class="config-panel panel-scroll">
        <div class="row space-between">
          <div>
            <div class="config-label">
              {{ $t('general') }}
            </div>
            <div class="config-description">
              {{ $t('settings.general.description') }}
            </div>
          </div>
          <div>
            <router-link
              :to="{name: 'GeneralSettingsPage', params: { serviceID: serviceID }}"
              class="next-step"
              :aria-label="$t('general.settings')"
              :title="$t('general.settings')"
            />
          </div>
        </div>
        <template>
          <div class="row space-between">
            <div>
              <div class="config-label">
                {{ $t('queues') }}
              </div>
              <div class="config-description">
                {{ $t('settings.queues.description') }}
              </div>
            </div>
            <div>
              <router-link
                :to="{name: 'QueuesSettingsPage', params: { serviceID: serviceID }}"
                class="next-step"
                :aria-label="$t('queues.management')"
                :title="$t('queues.management')"
              />
            </div>
          </div>
          <div
            v-if="isAdminOfService"
            class="row space-between"
          >
            <div>
              <div class="config-label">
                {{ $t('operators') }}
              </div>
              <div class="config-description">
                {{ $t('settings.operators.description') }}
              </div>
            </div>
            <div>
              <router-link
                :to="{name: 'OperatorsSettingsPage', params: { serviceID: serviceID }}"
                class="next-step"
                :aria-label="$t('operators.management')"
                :title="$t('operators.management')"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    serviceID: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['loggedUser']),
    isAdminOfService () {
      return (
        this.loggedUser.acl[this.serviceID] === 'manager' ||
        this.loggedUser.roles.includes('admin')
      )
    }
  }
}
</script>
